import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { DataProvider } from "./src/utils/Context/DataContext";

//css
import "./src/assets/libraries/bootstrap/css/bootstrap.min.css";
import "./src/assets/libraries/fontawesome/css/all.min.css";
import "./src/assets/css/style.css";

//js
// import "bootstrap/dist/js/bootstrap.min.js";

//Components
import OutletLayout from "./src/components/OutletLayout/OutletLayout";
import AdminLayout from "./src/components/AdminLayout/AdminLayout";

//Pages
import Home from "./src/pages/Home/Home";
import CreateBrand from "./src/pages/Home/CreateBrand";

//AdminPages
import AdminDashboard from "./src/pages/Admin/Dashboard/AdminDashboard";
import AdminOutlet from "./src/pages/Admin/Outlet/AdminOutlet";
import AdminViewOutlet from "./src/pages/Admin/Outlet/AdminViewOutlet";
import AdminUserRoles from "./src/pages/Admin/UserRoles/AdminUserRoles";
import AdminUserRolesAdd from "./src/pages/Admin/UserRoles/AdminUserRolesAdd";
import AdminUsers from "./src/pages/Admin/Users/AdminUsers";
import AdminService from "./src/pages/Admin/Service/AdminService";
import AdminAddService from "./src/pages/Admin/Service/AdminAddService";
import AdminEvent from "./src/pages/Admin/Event/AdminEvent";

//OutletPages
import OutletDashboard from "./src/pages/Outlet/Dashboard/OutletDashboard";
import OutletService from "./src/pages/Outlet/Service/OutletService";
import OutletEvent from "./src/pages/Outlet/Event/OutletEvent";
import OutletOrder from "./src/pages/Outlet/Order/OutletOrder";
import OutletAssign from "./src/pages/Outlet/Assign/OutletAssign";
import OutletCompany from "./src/pages/Outlet/Company/OutletCompany";
import OutletUsers from "./src/pages/Outlet/Users/OutletUsers";
import OutletTask from "./src/pages/Outlet/Task/OutletTask";
import OutletProfile from "./src/pages/Outlet/Profile/OutletProfile";
import OutletAddOrder from "./src/pages/Outlet/Order/AddOrder";
import ViewOrder from "./src/pages/Outlet/Order/ViewOrder";
import SalaryWork from "./src/pages/Outlet/SalaryWork/SalaryWork";
import MonthlySalary from "./src/pages/Outlet/MonthlySalary/MonthlySalary";
import OutletEditors from "./src/pages/Outlet/Editors/OutletEditors";
import OutletEditorMonthlySalary from "./src/pages/Outlet/Editors/OutletEditorMonthlySalary";
import OutletEditorWorkSalary from "./src/pages/Outlet/Editors/OutletEditorWorkSalary";

import OutletAddService from "./src/pages/Outlet/Service/OutletAddService";
import OrderRequest from "./src/pages/Outlet/OrderRequest/OrderRequest";
import CompletedTask from "./src/pages/Outlet/CompletedTask/CompletedTask";
//
import Loader from "./src/utils/Loader";
import { usePromiseTracker } from "react-promise-tracker";
import ViewCompany from "./src/pages/Outlet/Company/ViewCompany";
import Account from "./src/pages/Admin/Account/Account";

export default function App() {
  console.log("App before mount :");

  useEffect(() => {
    console.log("App On mount :");
  }, []);
  return (
    <DataProvider>
      <Loader promiseTracker={usePromiseTracker} />
      <BrowserRouter>
        <QueryParamProvider ReactRouterRoute={RouteAdapter}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/create_brand" element={<CreateBrand />} />
            <Route path="brand/:brand_id" element={<AdminLayout />}>
              <Route index element={<Navigate to="dashboard" />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="outlet" element={<AdminOutlet />} />
              <Route
                path="view_outlet/:outlet_id/:tab_value"
                element={<AdminViewOutlet />}
              />
              <Route path="userroles" element={<AdminUserRoles />} />
              <Route
                path="userroles/:page_type/:role_type/:role_id"
                element={<AdminUserRolesAdd />}
              />
              <Route path="users" element={<AdminUsers />} />
              <Route path="service" element={<AdminService />} />
              <Route path="service/:service_id" element={<AdminAddService />} />
              <Route path="event" element={<AdminEvent />} />
              <Route path="account" element={<Account />} />
            </Route>

            <Route
              path="outlet/:brand_id/:outlet_id"
              element={<OutletLayout />}
            >
              <Route index element={<Navigate to="dashboard" />} />
              <Route path="dashboard" element={<OutletDashboard />} />
              <Route path="service" element={<OutletService />} />
              <Route
                path="service/:service_id"
                element={<OutletAddService />}
              />
              {/* <Route path="event" element={<OutletEvent />} /> */}
              <Route path="company" element={<OutletCompany />} />
              <Route path="viewcompany/:company_id" element={<ViewCompany />} />
              <Route path="addorder/:company_id" element={<OutletAddOrder />} />
              <Route path="vieworder/:order_id" element={<ViewOrder />} />

              <Route path="user" element={<OutletUsers />} />
              <Route path="order">
                <Route path=":id" element={<OutletOrder />} />
                <Route path="addorder" element={<OutletAddOrder />} />
                <Route path="vieworder/:id" element={<ViewOrder />} />
              </Route>
              <Route path="assign" element={<OutletAssign />} />
              <Route path="task" element={<OutletTask />} />
              <Route path="profile" element={<OutletProfile />} />
              <Route path="salarywork/:id" element={<SalaryWork />} />
              <Route path="monthlysalary/:id" element={<MonthlySalary />} />
              <Route path="editors">
                <Route path="" element={<OutletEditors />} />
                <Route
                  path="monthlysalary/:sp_id"
                  element={<OutletEditorMonthlySalary />}
                />
                <Route
                  path="worksalary/:sp_id"
                  element={<OutletEditorWorkSalary />}
                />
              </Route>
              <Route
                path="order_request/:company_id"
                element={<OrderRequest />}
              />
              <Route path="completed_task" element={<CompletedTask />} />
            </Route>
          </Routes>
        </QueryParamProvider>
      </BrowserRouter>
    </DataProvider>
  );
}

function RouteAdapter({ children }: any) {
  const navigate = useNavigate();
  const location = useLocation();

  const adaptedHistory = React.useMemo(
    () => ({
      replace(location: any) {
        navigate(location, { replace: true, state: location.state });
      },
      push(location: any) {
        navigate(location, { replace: false, state: location.state });
      },
    }),
    [navigate]
  );
  return children({ history: adaptedHistory, location });
}
